export const SCREENS = {
    MOBILE: 768,
    TABLET: 820,
    DESKTOP: 1024,
};

export const ROUTES = {
    HOME: "/",
    ABOUTUS: "/about-us",
    PORTFOLIO: "/portfolio",
    LOGIN: "/login",
    SIGNUP: "/create-account",
    GETTING_STARTED: "/getting-started",
    PROJECT: "/create-project",
    POLICY: "/privacy-policy",
    DASHBOARD: "/account/dashboard",
    PROFILE: "/account/profile",
};

export const PLATFORMS = [
    { title: "Website", value: "Website" },
    { title: "Mobile", value: "Mobile" },
    { title: "Both", value: "Both" },
];

export const CATEGORY = [
    { title: "Finance", value: "Finance" },
    { title: "Shopping", value: "Shopping" },
    { title: "Entertainment", value: "Entertainment" },
    { title: "Education", value: "Education" },
    { title: "Health and Fitness", value: "Health and Fitness" },
    { title: "Travel", value: "Travel" },
    { title: "Social Network", value: "Social Network" },
    { title: "Sports", value: "Sports" },
    { title: "Lifestyle", value: "Lifestyle" },
    { title: "Productivity", value: "Productivity" },
    { title: "Food & Drinks", value: "Food & Drinks" },
];

export const DESIGNATION = [
    { title: "Developer", value: "Developer" },
    { title: "Designer", value: "Designer" },
    { title: "Marketer", value: "Marketer" },
    { title: "CEO", value: "CEO" },
    { title: "CTO", value: "CTO" },
]

export const DEFAULTS = {
    avatar: "/avatar.png",
};

export const PLANS = [
    {
        title: "Free",
        description:
            "A great plan tailored for UI/UX designers, software developers, product managers and startup founder looking to flesh out a product idea quickly",
        features: {
            included: ["Unlimited product design", "Export as image only", "Unlimited design categories"],
            excluded: [
                "Unlimited no. of AI design adjustments",
                "Export as code (HTML/CSS/JS)",
                "User testing for 10 users",
                "Post production tracking and design suggestions",
                "Design Consulting & Custom design adjustments",
            ],
        },
    },
    {
        title: "Standard",
        description:
            "A great plan tailored for UI/UX designers, software developers, product managers and startup founder looking to flesh out a product idea quickly",
        features: {
            included: [
                "Unlimited product design",
                "Unlimited design categories",
                "Unlimited no. of AI design adjustments",
                "Export as image and Figma only",
            ],
            excluded: [
                "Export as code (HTML/CSS/JS)",
                "User testing for 10 users",
                "Post production tracking and design suggestions",
                "Design Consulting & Custom design adjustments",
            ],
        },
    },
    {
        title: "Pro",
        description:
            "The perfect plan for UI/UX designers, software developers, product managers and startup founders who wants to do more than just design a product",
        features: {
            included: [
                "Unlimited product design",
                "Unlimited design categories",
                "Unlimited no. of AI design adjustments",
                "Export as image, Figma and code (HTML/CSS/JS)",
                "User testing for 10 users",
                "Post production tracking and design suggestions",
            ],
            excluded: ["Design Consulting & Custom design adjustments"],
        },
    },
];